import React, { useEffect, useState } from "react"
import { FastField, useFormikContext } from "formik"
import { getBusinessNature, getCountries } from "../../../../Helpers"
import FormError from "../../../../formError"
import { useQuery } from "react-query"
import CustomInput from "../../../../customInput"
import CustomSelectInput from "../../../../CustomSelectInput"

const BasicBusinessInfo = () => {
  const { errors, touched, values, setFieldValue } = useFormikContext()
  const [businessNature, setBusinessNature] = useState([])
  const [country, setCountry] = useState([])

  const countries = async () => {
    return getCountries()
      .then((res) => {
        setCountry(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getBusinesses = async () => {
    return getBusinessNature()
      .then((res) => {
        setBusinessNature(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  const {
    isLoading: statesLoading,
    error: stateError,
    data: st = {
      data: [],
    },
    isFetching: isFetchingStates,
  } = useQuery("st", () =>
    fetch(`https://apigateway.sparkleapp.in/api/v1/kyc/states`).then((res) =>
      res.json()
    )
  )

  useEffect(() => {
    countries()
    getBusinesses()
  }, [])

  return (
    <>
      <div className="form-row justify-between">
        <CustomInput
          className="col-md-5"
          label="Business Name Sample 1"
          name="business_name1"
          type="text"
          touched={touched}
          errors={errors}
        />

        <CustomInput
          className="col-md-5"
          label="Business Name Sample 2"
          name="business_name2"
          type="text"
          touched={touched}
          errors={errors}
        />
      </div>
      <div className="form-row justify-between">
        <CustomInput
          className="col-md-5"
          label="Business Name Sample 3"
          name="business_name3"
          type="text"
          touched={touched}
          errors={errors}
        />

        <CustomInput
          className="col-md-5"
          label="Business Name Sample 4"
          name="business_name4"
          type="text"
          touched={touched}
          errors={errors}
        />
      </div>

      <div className="form-row justify-between">
        <CustomSelectInput
          additionalClasses="col-md-5"
          label="Purpose of the business"
          name="business_nature"
          touched={touched}
          errors={errors}
          labelKey="display"
          valueKey="value"
          options={businessNature}
        />
        {values.business_nature === "Others" && (
          <CustomInput
            className="col-md-5"
            label="Other business nature"
            name="other_business_nature"
            type="text"
            touched={touched}
            errors={errors}
          />
        )}
      </div>

      <div className="form-row justify-between">
        <CustomSelectInput
          additionalClasses="col-md-5"
          label="Country"
          name="country"
          touched={touched}
          errors={errors}
          labelKey="display"
          valueKey="value"
          options={country}
        />

        <div className="form-group col-md-5">
          <label htmlFor="state">State</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="state"
            name="state"
          >
            <option value="" label="Select State">
              Select State
            </option>
            {st?.data.map((data) => (
              <option key={data.id} value={data.name}>
                {data.name}
              </option>
            ))}
          </FastField>

          <FormError touched={touched.state} message={errors.state} />
        </div>
      </div>

      <div className="form-row">
        <CustomInput
          className="col-md-5"
          label="City"
          name="city"
          type="text"
          touched={touched}
          errors={errors}
        />
      </div>

      <div className="form-row  ">
        <div className="form-group col-md-12">
          <label htmlFor="type_of_business">Business address</label>
          <FastField
            className="form-control"
            id="address"
            name="address"
            as="textarea"
            rows="3"
          />

          <FormError touched={touched.address} message={errors.address} />
        </div>
      </div>
    </>
  )
}
export default BasicBusinessInfo
